import React, { useState } from 'react';
import { TextField } from '@cimpress/react-components';

const TextFieldExampleArea = () => {
  const [text, setText] = useState('');

  const onInputChange = e => {
    setText(e.target.value);
  };

  return (
    <TextField
      name="simple"
      label="Simple Text Field as an area"
      value={text}
      onChange={e => onInputChange(e)}
      type="textarea"
    />
  );
};

export default TextFieldExampleArea;
